---
fr:
  activemodel:
    attributes:
      green_months_bulk_update_form:
        from_month: De (mois)
        realized_price: Prix (NOK/MWh)
        to_month: À (mois)
  errors:
    messages:
      from_month_should_not_be_after_to_month: De (mois) ne devrait pas être après À (mois)
  green_months:
    actions: Actions
    available_years: Années disponibles
    header: "%{type} réalisé pour %{power_plant}"
    realized_price: Prix [NOK] par MWh
    volume: Volume [MWh]
  green_months_bulk_update_form:
    header: Définir les prix %{type} pour une période de temps
  messages:
    bulk_update_executed: Mise à jour en masse exécutée
  update_all_green_months:
    header: Prix réalisés pour %{power_plant} %{year}
